import type { Condition } from '../../../hooks/useProductData';
import { getHumanizedMaxValue } from '../../humanization';

export const getBusinessRegistrationConditions = (item): Condition[] => {
  // Поля: Открытие, Онлайн, Без похода в налоговую, РКО от 0руб
  const conditions = [];

  const open = getHumanizedMaxValue(
    {
      from: item.minSum,
      to: item.maxSum,
    },
    ' ₽',
  );
  conditions.push({ value: open, description: 'Открытие' });

  const withoutFNS = item.registrationTypes?.includes('noFns');
  withoutFNS && conditions.push({ value: 'Да', description: 'Без походов в налоговую' });

  const online = item.registrationTypes?.includes('online');
  online && conditions.push({ value: 'Да', description: 'Оформление онлайн' });

  const pko = item.dictAdvantages?.includes('pko');
  pko && conditions.push({ value: 'Да', description: 'РКО от 0 руб.' });

  return conditions;
};
